<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

import OtherHealthProfesionalsList from './otherProfesionals/OtherProfesionalsList'
export default {
  components: {
    OtherHealthProfesionalsList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/OtherHealthProfesionals.vue